import { useContext, useEffect } from "react"
import { AppContext } from "../../context/AppContext"
import { MapContext } from "../../context/MapContext";
import axios from 'axios';
import { inoutflowBgLayers, inoutflowLayers } from "./layers";
import { Style, Fill } from 'ol/style';
import GeoJSON from 'ol/format/GeoJSON';
import InoutflowLegend from "../legend/InoutflowLegend";
import { cql2filter } from "../../common/func/cql2filter";
import { abstractFetch } from "../../common/func/abstractFetch";

export default function InoutflowMap() {
  const {step, mapMode, setBackdropOpen, GISSERVER_URL} = useContext(AppContext);
  const { inoutLegendControlOpen, setInoutLegendControlOpen,
          inoutCollapseBgMap, setInoutCollapseBgMap,
          inOutHubGridOpacity, setInOutHubGridOpacity,
          inoutflowBgMap, setInoutflowBgMap,
          inoutflowMapRef,
          inflowIndex, outflowIndex,
          zoomLevel,
          createMap
        } = useContext(MapContext);

  const handleInOutflowView = (type) => {
    const value = type === 'plus' ? 1 : -1;
    inoutflowMapRef.current
      .getView()
      .setZoom(inoutflowMapRef.current.getView().getZoom() + value);
  };

  const pointerInOutHubFeature = (e) => {
		inoutflowMapRef.current.forEachFeatureAtPixel(
			e.pixel,
			inOutPointerMoveCallBack
		);
	};

	let inOutSelected = null;
	const inOutPointerMoveCallBack = (selectedFeature, layer) => {
		if (layer.get('title') === '유출입 중심거점') {
			inOutSelected = selectedFeature;
			const inoutFlowSelectFeatureColor = new Style({
				fill: new Fill({ color: '#ff0a0a', opacity: '1' }),
			});
			selectedFeature.setStyle(inoutFlowSelectFeatureColor);
			return true;
		} else {
		}
	};

  // 최초 렌더링
	useEffect(() => {
		setBackdropOpen(true);
		
		inoutflowMapRef.current = createMap(
			'inoutMap',
			Object.keys(inoutflowBgLayers).map((key) => inoutflowBgLayers[key]),
			Object.keys(inoutflowLayers).map((key) => inoutflowLayers[key])
		)
		inoutflowMapRef.current.on('pointermove', (e) => {
			if (inOutSelected !== null) {
				inOutSelected.setStyle(undefined);
				inOutSelected = null;
			}
			pointerInOutHubFeature(e);
		});

		const fetchXmlString = async (inflowIndex, outflowIndex) => {
			const indexXmlString = await cql2filter(
				'pc_in_val>=' + inflowIndex + 'and pc_out_val>=' + outflowIndex
			);

			const indexFeatureRequest = {
				service: 'WFS',
				version: '1.0.0',
				request: 'GetFeature',
				outputFormat: 'application/json',
				srsName: 'EPSG:3857',
				typeName: 'pinogio:flow_pc_grid_2021',
				filter: indexXmlString,
			}; 

			abstractFetch(indexFeatureRequest)
				.then((res) => {
					inoutflowLayers.centralHubV.getSource().clear();
					inoutflowLayers.centralHubV
						.getSource()
						.addFeatures(new GeoJSON().readFeatures(res));

						setBackdropOpen(false);
			});

			const inoutMapZoom = inoutflowMapRef.current.getView().getZoom();

			if (inoutMapZoom <= 11) {
				inoutflowLayers.centralHubT.getSource().updateParams({
					filter: await cql2filter(`pc_in_val>=${inflowIndex} and pc_out_val>=${outflowIndex}`),
				});
				inoutflowLayers.centralHubT.getSource().refresh();
			}
		}
		fetchXmlString(inflowIndex, outflowIndex);
	}, []);

  useEffect(() => {
		const fetchXmlString = async (inflowIndex, outflowIndex) => {
			const indexXmlString = await cql2filter(
				'pc_in_val>=' + inflowIndex + 'and pc_out_val>=' + outflowIndex
			);

			const indexFeatureRequest = {
				service: 'WFS',
				version: '1.0.0',
				request: 'GetFeature',
				outputFormat: 'application/json',
				srsName: 'EPSG:3857',
				typeName: 'pinogio:flow_pc_grid_2021',
				filter: indexXmlString,
			}; 

			abstractFetch(indexFeatureRequest)
				.then((res) => {
					inoutflowLayers.centralHubV.getSource().clear();
					inoutflowLayers.centralHubV
						.getSource()
						.addFeatures(new GeoJSON().readFeatures(res));
			});

			inoutflowLayers.centralHubT.getSource().updateParams({
				filter: await cql2filter(`pc_in_val>=${inflowIndex} and pc_out_val>=${outflowIndex}`),
			});
			inoutflowLayers.centralHubT.getSource().refresh();
		}
		fetchXmlString(inflowIndex, outflowIndex);
	}, [step]);

  return(
    <div className={mapMode === 'inout' ? 'partition--single' : null}>
					{step === 2 ? (
						<>
							<div className="mapTit redBG">유입+유출 거점</div>
							{/* {zoomLevel < 11 ? ( */}
							<div className="zoomTooltip">
								{zoomLevel < 9
									? '화면을 확대하면 격자의 정보를 볼 수 있습니다.'
									: '격자를 클릭하면 해당 격자의 정보를 확인할 수 있습니다.'}
							</div>
							{/* ) : null} */}
						</>
					) : null}
					<InoutflowLegend
            step={2}
						legendControlOpen={inoutLegendControlOpen}
						setLegendControlOpen={setInoutLegendControlOpen}
						collapseBgMap={inoutCollapseBgMap}
						setCollapseBgMap={setInoutCollapseBgMap}
						hubGridOpacity={inOutHubGridOpacity}
						setHubGridOpacity={setInOutHubGridOpacity}
						flowBgMap={inoutflowBgMap}
						setFlowBgMap={setInoutflowBgMap}
            bgLayers={inoutflowBgLayers}
						flowLayers={inoutflowLayers}
						target={{
							cssName: 'two',
							color: 'redBox',
							name: '유입+유출',
							flowHub: 'inoutflowHub',
						}}
					/>

					<div id="inoutMap" className="mapArea" />
					<div className="mapZoom">
						<button onClick={() => handleInOutflowView('plus')}>
							<img src="img/zoomPlus.png" alt="확대" />
						</button>
						<button onClick={() => handleInOutflowView('minus')}>
							<img src="img/zoomMin.png" alt="축소" />
						</button>
					</div>
				</div>
  )
}